<template>
  <div>

    <div class="d-flex flex-column mb-4">
      <div class="bold-text profil-subsection"> {{ $t('Profile.personal.data') }}</div>
    </div>
    <b-form @submit.stop.prevent="clickOnValidateBtn">

      <div class="row">
        <div class="col-md-6">
          <b-form-group
            :label="$t('user.Firstname') + '*'"
            label-for="firstName-input"
            class="bold-label mb-4"
            :invalid-feedback="form.firstName.invalidFeedback"
            :state="form.firstName.state">
            <b-form-input
              id="firstName-input"
              v-model="form.firstName.value"
              type="text"
              maxlength="250"
              :state="form.firstName.state"
              required>
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('user.Lastname') + ' *'"
            label-for="lastName-input"
            class="bold-label mb-4"
            :invalid-feedback="form.lastName.invalidFeedback"
            :state="form.lastName.state">
            <b-form-input
              id="lastName-input"
              v-model="form.lastName.value"
              type="text"
              maxlength="250"
              :state="form.lastName.state"
              required>
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">

          <b-form-group
            :label="$t('user.Username') + ' *'"
            label-for="username-input"
            class="bold-label mb-4"
            :invalid-feedback="form.username.invalidFeedback"
            :state="form.username.state">
            <b-form-input
              id="username-input"
              v-model="form.username.value"
              type="email"
              :state="form.username.state"
              required
              @update="removeInvalidFeedback('username')">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :invalid-feedback="form.phoneNumber.invalidFeedback"
            :label="$t('user.PhoneNumber')"
            :state="form.phoneNumber.state"
            class="bold-label mb-4"
            label-for="phoneNumber-input">
            <vue-phone-number-input
              id="phone-input"
              v-model="form.phoneNumber.inputValue"
              :error="form.phoneNumber.error"
              default-country-code="FR"
              tabindex="3"
              required
              @update="checkPhone"/>
          </b-form-group>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import api from "../../../services/api";
import i18n from "../../../i18n";

export default {
  name: "UserEdit",

  props:{
    userId:Number,
    user:Object
  },

  data () {
    return {
      localUser: {...this.user},
      form: {
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            error: null,
            value: null,
            inputValue: null
          }
      }
    }
  },

  emits: [
    'userUpdated',
  ],

  mounted() {
    if(this.localUser){
      this.setInitialValues()
    }
  },

  methods:{
    setInitialValues () {
      this.form.firstName.value = this.localUser.firstName
      this.form.lastName.value = this.localUser.lastName
      this.form.username.value = this.localUser.username
      this.form.phoneNumber.value = this.localUser.phoneNumber
      this.form.phoneNumber.inputValue = this.localUser.phoneNumber
    },

    clickOnValidateBtn () {
      this.onSubmit()
    },

    onSubmit () {
      let data = new FormData()
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)

      api({
        method: 'POST',
        url: `/user/updateProfile`,
        data: data
      })
        .then((response) => {
          this.localUser = response.data
          this.successToast(this.form.username.value)
          this.$emit('userUpdated',this.localUser)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: '/',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    checkPhone(value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
      this.askConfirm = true
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast (userName) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + userName + '" ' + this.$i18n.t('modified'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/profileEdit/MineUserEdit.vue